import CryptoJS from 'crypto-js';

const key = 'c2libGktcGlraW5p'

export const decryptData = (encryptedText) => {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key.padEnd(32));
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
    const decrypted = CryptoJS.AES.decrypt(encryptedText, keyUtf8, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
